import IndexApp from '../router/IndexApp';
import './styles/App.css';

function App() {
  return (
    <div className="App">
        <IndexApp/>
    </div>
  );
}

export default App;
